import getFields from '../elements/getFields';

/**
 * Returns value of element, removing phone number mask if element is phone_number input
 *
 * @param {Element} el
 */
export const conditionedValue = el => {
  if (el.name === 'phone_number') {
    // unmask phone_number
    return el.value.replace(/[()\-# ]/g, '');
  } else {
    return el.value;
  }
};

/**
 * Returns true if given element has a value
 *
 * @param {Element} el
 */
export const hasValue = el => {
  if (el.type === 'checkbox' || el.type === 'radio') {
    return el.checked;
  } else {
    return !!el.value;
  }
};

/**
 * Returns form fields in a nice friendly JS object, filtering out disabled inputs
 * and inputs that don't a value
 * Extracted from https://codepen.io/gabrieleromanato/pen/LpLVeQ
 *
 * @param {Element} form
 */
export default function serialize(form) {
  const obj = {};
  if (!form || form.nodeName !== 'FORM') {
    return obj;
  }

  getFields(form)
    .filter(field => !field.disabled)
    .forEach(field => {
      const name = field.name;
      if (name && hasValue(field)) {
        obj[name] = conditionedValue(field);
      }
    });
  return obj;
}
